module.exports = __webpack_public_path__ + "img/logo.fa714232.jpg";